import React from 'react';
import { Row, Col, Button, Navbar, FormGroup, FormControl, Alert, ControlLabel } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';
import DropDownInput from './common/DropDownInput.jsx';

export default class LabelRestoreComponent extends React.Component {

  componentDidMount() {
  }

  componentWillUnmount() {
    this.props.cleanInput();
  }

  restoreLabel() {
    this.props.restoreLabel(this.props.labelRestoreFormBean);
  }

  render() {
    let alertDiv = null;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
          {this.props.alertMessage}
        </Alert>
      );
    }

    return (
      <div>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={6}>
            {alertDiv}
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12}>
            <Button onClick={(event) => {
              this.restoreLabel();
            }} bsStyle="info">
              還原洗標 ID
					  </Button>
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={6}>
            <DropDownInput id="deletedLogId"
              label="刪除時間"
              options={this.props.deletedLogIds.map((value, key) => ({ label: value.get('display'), value: value.get('label_log_id') })).toJS()}
              onChange={(id, value, label) => {
                this.props.setValue('orderId', this.props.orderId);
                this.props.setValue('deletedLogId', value);
              }}
            />
          </Col>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/LabelRestoreComponent.jsx